import { findIndex, isEmpty, remove } from 'lodash';
import { extensionElements, trackingChangeExtensionType } from '@ispm-shared/modules/bpmn/diagram-element-terms';
import { BaseModdleElement } from '@ispm/shared/bpmn-io/bpmn-models';
import {OldTrackingChangeType, TrackingChangeType} from "diagram-js/lib/model";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";

export class BpmnExtensionHelper {
    constructor(private moddle, private modeling) {
    }

    private addExtension(element, extension: BaseModdleElement) {
        const businessObject = element.businessObject;
        const bpmnExtensionElements = businessObject.extensionElements || this.moddle.create(extensionElements);
        if (isEmpty(bpmnExtensionElements.values)) {
            bpmnExtensionElements.values = [extension];
        }
        else {
            bpmnExtensionElements.values.push(extension);
        }
        this.modeling.updateProperties(element, { extensionElements: bpmnExtensionElements});
    }

    public replaceExtension(element, extension: BaseModdleElement) {
        const businessObject = element.businessObject;
        const bpmnExtensionElements = businessObject.extensionElements;
        const index = findIndex(bpmnExtensionElements.values, { $type: extension.$type});
        bpmnExtensionElements.values.splice(index, 1, extension);
        this.modeling.updateProperties(element, { extensionElements: bpmnExtensionElements});
    }

    public addOrReplaceExtension(element, extension: BaseModdleElement) {
        const businessObject = element.businessObject;
        const bpmnExtensionElements = businessObject.extensionElements;
        if ((!bpmnExtensionElements || isEmpty(bpmnExtensionElements.values)) || findIndex(bpmnExtensionElements.values, { $type: extension.$type}) < 0) {
            this.addExtension(element, extension);
        }
        else {
            this.replaceExtension(element, extension);
        }
    }

    public removeExtension(element, type) {
        const businessObject = element.businessObject;
        const bpmnExtensionElements = businessObject.extensionElements;
        if (bpmnExtensionElements && !isEmpty(bpmnExtensionElements.values)) {
            remove(bpmnExtensionElements.values, ((extension: BaseModdleElement) => extension.$type === type));
        }
        this.modeling.updateProperties(element, { extensionElements: bpmnExtensionElements});
    }

    public markElementForChange(element, trackingChangeType : TrackingChangeType | OldTrackingChangeType){
      const trackingChange = ModelingUtil.getTrackingChange(element);
      if (trackingChange) {
        if (trackingChange.type && trackingChange.type !== trackingChangeType) {
          trackingChange.type = trackingChangeType;
          this.replaceExtension(element, trackingChange);
        }
      } else {
        const trackingChangesExtension = this.moddle.create(trackingChangeExtensionType);
        trackingChangesExtension.type = trackingChangeType;
        this.addExtension(element, trackingChangesExtension);
      }
    }
}
